exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".AppSpinner__spinnerWrapper___30hNY {\n  display: block;\n  position: absolute;\n  z-index: 10;\n  top: 50%;\n  left: 50%;\n  /*\n     Absolute positioning centering needs to adjust for the size of the spinner.\n     Otherwise, the spinner appears at the top left corner of the 4th\n     quadrant instead of the middle of the screen.\n   */\n  transform: translate(-50%, -50%);\n}\n", ""]);
// Exports
exports.locals = {
	"spinnerWrapper": "AppSpinner__spinnerWrapper___30hNY"
};